import { silentLog } from '@pearsontechnology/bronte-lib-fullstory';
import { fetchFromRTM, fetchFromRTMWithRetries } from '../RTMResolvers';
import * as constants from './constants';
import TimestampManager from './TimestampManager';

const CoursewareItemResolver = {
  sendEvaluateRequest: async (deploymentId, interactiveId, timeId, cohortId) => {
    const message = {
      type: constants.RTM_LEARNER_EVALUATE,
      deploymentId,
      interactiveId,
      cohortId,
    };

    if (timeId) {
      message.timeId = timeId;
    }

    const response = await fetchFromRTMWithRetries(
      message,
      constants.RTM_LEARNER_EVALUATE_OK,
      constants.RTM_LEARNER_EVALUATE_ERROR,
    );

    return response;
  },

  sendResultEvaluateRequest: async (deploymentId, interactiveId, cohortId) => {
    const message = {
      type: constants.RTM_LEARNER_EVALUATE_GET,
      deploymentId,
      interactiveId,
      cohortId,
    };

    const response = await fetchFromRTMWithRetries(
      message,
      constants.RTM_LEARNER_EVALUATE_GET_OK,
      constants.RTM_LEARNER_EVALUATE_GET_ERROR,
    );

    return response;
  },

  sendRestartRequest: async (deploymentId, activityId, cohortId) => {
    const message = {
      type: constants.RTM_LEARNER_RESTART,
      deploymentId,
      activityId,
      cohortId,
    };

    const response = await fetchFromRTM(
      message,
      constants.RTM_LEARNER_RESTART_OK,
      constants.RTM_LEARNER_RESTART_ERROR,
    );

    return response;
  },

  leanerStudentScopeSubscribe: async (studentScopeURN, listener, aggregation) => (
    aggregation.subscribe(studentScopeURN, listener)
  ),

  sendGraphqlQuery: async (query, parameters) => {
    const message = {
      type: constants.RTM_GRAPHQL_QUERY,
      query,
      parameters,
    };

    const response = await fetchFromRTMWithRetries(
      message,
      constants.RTM_GRAPHQL_QUERY_OK,
      constants.RTM_GRAPHQL_QUERY_ERROR,
    );

    return response;
  },

  setStudentScope: async (
    sourceId,
    deploymentId,
    studentScopeURN,
    data,
    timeId,
    cohortId
  ) => {
    const message = {
      type: constants.RTM_LEARNER_STUDENT_SCOPE_SET,
      sourceId,
      deploymentId,
      studentScopeURN,
      data,
      timeId,
      cohortId,
    };
    silentLog(JSON.stringify(message));
    const response = await fetchFromRTM(
      message,
      constants.RTM_LEARNER_STUDENT_SCOPE_SET_OK,
      constants.RTM_LEARNER_STUDENT_SCOPE_SET_ERROR,
    );

    TimestampManager.updateIfLatest(sourceId, timeId);
    silentLog(JSON.stringify(response));
    return response;
  },
};

export default CoursewareItemResolver;
